<template>
  <div id="ge_game" :standalone="!inIframe()" :offline="config.offline" :leaderboard="config.leaderboard">
    <main ref="main">
      <router-view :version="version" :key="$router.history.current.meta.section+this.$router.history.current.params.number"></router-view>
    </main>
    <div class="resolution-message" ref="res">
      <Background :small="true"></Background>
      <div class="message-content">
        <div class="bluebar"></div>
        <h1>Become a <b>SCADA Superhero!</b></h1>
        <p>Take on the challenge of looking after the water supply for Water Town</p>
        <div class="resolution-warning">
          <div>
            <img src="@/assets/img/laptop.svg" >&nbsp;<img src="@/assets/img/tablet.svg" class="tablet-icon">
          </div>
          <div>This game is optimized<br>for desktop or landscape tablet</div>
          <div v-if="rotate"><small>Please rotate your device</small></div>
        </div>
      </div>
    </div>
    <a class="fullscreen" title="Full Screen Mode" v-if="!fullscreenMode && fullscreenEnabled" @click="fullScreen(true)" ><img src="@/assets/img/fullscreen.svg" ></a>
    <a class="exit-fullscreen" title="Exit Full Screen [ESC]" v-if="fullscreenMode && fullscreenEnabled" @click="fullScreen(false)" ><img src="@/assets/img/exit-fullscreen.svg" ></a>
    <div v-if="!config.offline" class="version">{{version}}</div>
  </div>
</template>

<script>
import '@/assets/scss/fonts.scss'
import '@/assets/scss/reset.scss'
import '@/assets/scss/app.scss'
import config from '@/config.js'

import Background from '@/components/Background.vue'

export default {
  data: function () {
    return {
      version: '',
      fullscreenMode: false,
      fullscreenEnabled: true,
      rotate: false,
      config: config
    }
  },
  mounted: function () {
    const self = this
    window.addEventListener('message', function (ev) {
      if (ev.data === 'resize') {
        self.resize()
      }
    })
    window.addEventListener('load', function () {
      config.offline = config.isLocal()
    })
    window.addEventListener('resize', function () {
      self.resize()
    })
    self.resize()
    if (!this.fullscreenMethod(document.body)) {
      this.fullscreenEnabled = false
    }
    fetch('./version.txt?' + Math.random())
      .then(function (response) {
        return response.text()
      })
      .then(function (txt) {
        self.version = txt
      })
  },
  components: {
    Background
  },
  methods: {
    fullscreenMethod: function (element) {
      return element.requestFullScreen || element.webkitRequestFullscreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
    },
    checkFullscreen: function () {
      setTimeout(function () {
        if (!config.fullScreenElem()) {
          parent.postMessage('fullscreen', '*')
        }
      }, 100)
    },
    requestFullScreen: function (element) {
      const fullscreenMethod = this.fullscreenMethod(element)
      if (fullscreenMethod.name === 'webkitRequestFullscreen') {
        element.webkitRequestFullscreen()
        this.checkFullscreen()
      } else if (fullscreenMethod.name === 'webkitRequestFullScreen') {
        element.webkitRequestFullScreen()
        this.checkFullscreen()
      } else if (fullscreenMethod) {
        fullscreenMethod.call(element)
        this.checkFullscreen()
      }
    },
    fullScreen: function (active) {
      if (!active) {
        const cancelFullscreen = this.cancelFunction()
        if (cancelFullscreen) {
          document[cancelFullscreen]()
        }
        parent.postMessage('exitfullscreen', '*')
      }
      if (active) {
        this.requestFullScreen(document.body)
      }
    },
    cancelFunction: function () {
      const doc = document
      const func = doc.cancelFullScreen || doc.webkitCancelFullscreen || doc.webkitCancelFullScreen || doc.mozCancelFullScreen || doc.msCancelFullScreen
      if (func) return func.name
      return null
    },
    resize: function () {
      const main = this.$refs.main
      const res = this.$refs.res
      if (main) {
        let HEADERSIZE = 0
        let RES = 1024 / 768
        let EXT_HEIGHT = window.innerHeight
        const EXT_WIDTH = window.parent.innerWidth
        const fullScreenElem = config.fullScreenElem() || config.fullScreenElem(parent.document)
        if (fullScreenElem) {
          this.fullscreenMode = true
        } else {
          this.fullscreenMode = false
        }
        if (this.inIframe() && !fullScreenElem) {
          HEADERSIZE = 97
          RES = 0.7
          EXT_HEIGHT = window.parent.innerHeight
        }
        if (fullScreenElem) {
          RES = 0.75
        }
        this.zoomView()
        this.rotate = false
        if (EXT_HEIGHT > 1024 && EXT_WIDTH > 700 && EXT_WIDTH < 1024) {
          // this.rotate = true
        }
        if (main) {
          const vw = window.parent.innerWidth * RES
          const vh = Math.max(530, EXT_HEIGHT - HEADERSIZE)
          main.style.height = Math.min(vw, vh) + 'px'
        }
        if (res) {
          res.style.height = (window.parent.innerHeight - HEADERSIZE) + 'px'
        }
      }
      if (this.inIframe()) {
        parent.postMessage('resize', '*')
      }
      // const scale = Math.min(1.0, Math.max(0.5, document.body.clientWidth / 1540))
      // this.$refs.challenge.style.transform = 'scale(' + scale.toFixed(2) + ')'
      // this.$refs.tablet.style.transform = 'scale(' + scale.toFixed(2) + ')'
      // this.$refs.tutorial.$el.style.transform = 'scale(' + scale.toFixed(2) + ')'
      this.$forceUpdate()
    },
    zoomView: function () {
      const main = this.$refs.main
      const EXT_WIDTH = window.parent.innerWidth
      main.firstChild.style.zoom = ''
      if (EXT_WIDTH > 2000) {
        const myzoom = (EXT_WIDTH / 1920).toFixed(1)
        main.firstChild.style.zoom = myzoom
      }
    },
    inIframe: function () {
      return config.isIframe()
    }
  },
  computed: {
  },
  updated: function () {
    this.zoomView()
  }
}
</script>

<style lang="scss" scoped>
.version{
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 2px 8px;
  font-size: 14px;
  color: #666;
}
.tablet-icon{
  transform: rotate(-90deg);
}
.fullscreen, .exit-fullscreen{
  position: absolute;
  right: 20px;
  bottom: 18px;
  padding: 0;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  min-width: 32px;
  min-height: 32px;
  height: 2vw;
  width: 2vw;
  display: flex;
  justify-content:center;
  align-items: center;
  z-index: 1;
  img{
    display: inline-block;
    width: 81%;
    height: 81%;
    opacity: 0.8;
  }
}
.fullscreen img:hover{
  width: 86%;
  height: 86%;
  opacity: 1;
}
.exit-fullscreen img:hover{
  width: 75%;
  height: 75%;
  opacity: 1;
}
</style>
